import { render, staticRenderFns } from "./TextareaHighlightField.vue?vue&type=template&id=15bf505d"
import script from "./TextareaHighlightField.vue?vue&type=script&lang=js"
export * from "./TextareaHighlightField.vue?vue&type=script&lang=js"
import style0 from "./TextareaHighlightField.vue?vue&type=style&index=0&id=15bf505d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports